// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item-name {
  flex: 1;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: AppFontMedium;
  font-size: 16px;
  line-height: 100%;
  text-transform: uppercase;
  letter-spacing: -0.01em;
  color: #05121a;
  margin-bottom: 9px;
}

@media (min-width: 991px) {
  .item-image {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    background: transparent;
    padding: 18px 0;
    border: 0;
    height: 160px;
  }
}

.info {
  margin: 0;
  flex: 1;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: AppFont;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0;
  color: #41413f;
  margin-bottom: 8px;
}

.info-text {
  flex: 1;
  color: #656564;
}

.action-icon {
  width: 29px;
  height: 29px;
  margin-left: 25px;
}
@media (min-width: 991px) {
  .action-icon {
    display: none;
  }
}

.price-col {
  display: flex;
  flex-direction: column;
}
.price-col .price {
  margin: 0;
  margin-bottom: 8px;
  font-family: AppFontMedium;
  font-size: 14px;
  line-height: 110%;
  letter-spacing: 0;
  vertical-align: middle;
  text-align: end;
  color: #41413F;
}

.add-product-icon {
  height: 32px;
  width: 32px;
  margin-left: auto;
}

.item-row {
  margin-bottom: 20px;
  padding: 0px;
  height: 100%;
  min-height: 90px;
}
@media (min-width: 991px) {
  .item-row {
    background: transparent;
    border-radius: 0;
    cursor: pointer;
    height: 100%;
    border: 1.5px solid transparent;
    transition: border 0.2s ease;
  }
  .item-row ion-img {
    height: 100%;
  }
}

.item-info {
  padding: 0;
  padding-right: 8px;
  padding-left: 8px;
  height: 83%;
}
@media (min-width: 991px) {
  .item-info {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
}

app-tag {
  margin-left: 3px;
}

.lines-col {
  padding: 0;
  padding-bottom: 5px;
}
@media (min-width: 991px) {
  .lines-col {
    height: min-content;
    margin-top: auto;
  }
}

.first-line {
  display: block;
  height: 0.5px;
  width: 100%;
  margin: 0px 0px 0px 0px;
  content: "";
  background: #c0c0bf;
}

.second-line {
  display: block;
  height: 1px;
  width: 100%;
  margin: 5px 0px;
  content: "";
  background: #939393;
}

.add-btn {
  width: 25px;
  height: 25px;
  background: var(--ion-color-secondary);
  color: #ffffff;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  margin: 0px 0px 0px 5px;
}
@media (min-width: 991px) {
  .add-btn {
    display: none;
  }
}

.pfand-meirnveg {
  margin: 0;
  font-size: 12px;
}

.item-img {
  padding: 0;
}
@media (min-width: 991px) {
  .item-img {
    display: block;
  }
}

.image-wrapper {
  position: relative;
  width: 100%;
  aspect-ratio: 1;
  border-radius: 4px;
  overflow: hidden;
}
.image-wrapper .main-img {
  border-radius: 1px;
  overflow: hidden;
  object-fit: cover;
  width: 100%;
  aspect-ratio: 1;
}
.image-wrapper .main-img.default {
  height: 100%;
  object-fit: contain;
}
.image-wrapper .top-selling {
  position: absolute;
  top: 2px;
  left: 50%;
  transform: translateX(-50%);
  height: 25px;
  width: 25px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/item-view/item-view.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,OAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EAEA,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,uBAAA;EAEA,cAAA;EACA,kBAAA;AAHD;;ACdE;EDoBF;IAEE,sBAAA;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,uBAAA;IACA,eAAA;IACA,SAAA;IACA,aAAA;EAHA;AACF;;AAMA;EACC,SAAA;EACA,OAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EAEA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EAEA,cAAA;EAEA,kBAAA;AAND;;AAQA;EACC,OAAA;EACA,cAAA;AALD;;AAQA;EACC,WAAA;EACA,YAAA;EACA,iBAAA;AALD;ACvDE;EDyDF;IAKE,aAAA;EAHA;AACF;;AAMA;EACC,aAAA;EACA,sBAAA;AAHD;AAIC;EACC,SAAA;EACA,kBAAA;EAEA,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,eAAA;EAEA,cAAA;AAJF;;AAQA;EACC,YAAA;EACA,WAAA;EACA,iBAAA;AALD;;AAQA;EACC,mBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;AALD;ACzFE;ED0FF;IAOE,uBAAA;IACA,gBAAA;IACA,eAAA;IACA,YAAA;IACA,+BAAA;IACA,4BAAA;EAJA;EAUA;IACC,YAAA;EARD;AACF;;AAYA;EACC,UAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;AATD;AC7GE;EDkHF;IAOE,aAAA;IACA,sBAAA;IACA,2BAAA;EARA;AACF;;AAWA;EACC,gBAAA;AARD;;AAWA;EACC,UAAA;EACA,mBAAA;AARD;AC7HE;EDmIF;IAKE,mBAAA;IACA,gBAAA;EAPA;AACF;;AAUA;EACC,cAAA;EACA,aAAA;EACA,WAAA;EACA,uBAAA;EAEA,WAAA;EACA,mBAAA;AARD;;AAUA;EACC,cAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;AAPD;;AASA;EACC,WAAA;EACA,YAAA;EACA,sCAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,uBAAA;AAND;AClKE;ED8JF;IAYE,aAAA;EAJA;AACF;;AAOA;EACC,SAAA;EACA,eAAA;AAJD;;AAOA;EACC,UAAA;AAJD;AChLE;EDmLF;IAGE,cAAA;EAFA;AACF;;AAKA;EACC,kBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AAFD;AAIC;EACC,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;AAFF;AAIE;EACC,YAAA;EACA,mBAAA;AAFH;AAOC;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,2BAAA;EACA,YAAA;EACA,WAAA;AALF","sourcesContent":["@use '../../../theme/mixins' as *;\n\n.item-name {\n\tflex: 1;\n\tword-break: break-word;\n\tdisplay: -webkit-box;\n\t-webkit-line-clamp: 3;\n\t-webkit-box-orient: vertical;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\n\tfont-family: AppFontMedium;\n\tfont-size: 16px;\n\tline-height: 100%;\n\ttext-transform: uppercase;\n\tletter-spacing: -0.01em;\n\n\tcolor: #05121a;\n\tmargin-bottom: 9px;\n}\n\n.item-image {\n\t@include desktop {\n\t\tbox-sizing: border-box;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tbackground: transparent;\n\t\tpadding: 18px 0;\n\t\tborder: 0;\n\t\theight: 160px;\n\t}\n}\n\n.info {\n\tmargin: 0;\n\tflex: 1;\n\tword-break: break-word;\n\tdisplay: -webkit-box;\n\t-webkit-line-clamp: 3;\n\t-webkit-box-orient: vertical;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\n\tfont-family: AppFont;\n\tfont-size: 12px;\n\tline-height: 100%;\n\tletter-spacing: 0;\n\n\tcolor: #41413f;\n\n\tmargin-bottom: 8px;\n}\n.info-text {\n\tflex: 1;\n\tcolor: #656564;\n}\n\n.action-icon {\n\twidth: 29px;\n\theight: 29px;\n\tmargin-left: 25px;\n\t@include desktop {\n\t\tdisplay: none;\n\t}\n}\n\n.price-col {\n\tdisplay: flex;\n\tflex-direction: column;\n\t.price {\n\t\tmargin: 0;\n\t\tmargin-bottom: 8px;\n\n\t\tfont-family: AppFontMedium;\n\t\tfont-size: 14px;\n\t\tline-height: 110%;\n\t\tletter-spacing: 0;\n\t\tvertical-align: middle;\n\t\ttext-align: end;\n\n\t\tcolor: #41413F;\n\t}\n}\n\n.add-product-icon {\n\theight: 32px;\n\twidth: 32px;\n\tmargin-left: auto;\n}\n\n.item-row {\n\tmargin-bottom: 20px;\n\tpadding: 0px;\n\theight: 100%;\n\tmin-height: 90px;\n\n\t@include desktop {\n\t\tbackground: transparent;\n\t\tborder-radius: 0;\n\t\tcursor: pointer;\n\t\theight: 100%;\n\t\tborder: 1.5px solid transparent;\n\t\ttransition: border 0.2s ease;\n\n\t\t// &:hover {\n\t\t// \tborder: 1.5px solid var(--ion-color-primary);\n\t\t// }\n\n\t\tion-img {\n\t\t\theight: 100%;\n\t\t}\n\t}\n}\n\n.item-info {\n\tpadding: 0;\n\tpadding-right: 8px;\n\tpadding-left: 8px;\n\theight: 83%;\n\t@include desktop {\n\t\t// padding: 20px 12px;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: flex-start;\n\t}\n}\n\napp-tag {\n\tmargin-left: 3px;\n}\n\n.lines-col {\n\tpadding: 0;\n\tpadding-bottom: 5px;\n\n\t@include desktop {\n\t\theight: min-content;\n\t\tmargin-top: auto;\n\t}\n}\n\n.first-line {\n\tdisplay: block;\n\theight: 0.5px;\n\twidth: 100%;\n\tmargin: 0px 0px 0px 0px;\n\t// opacity: 0.5;\n\tcontent: '';\n\tbackground: #c0c0bf;\n}\n.second-line {\n\tdisplay: block;\n\theight: 1px;\n\twidth: 100%;\n\tmargin: 5px 0px;\n\tcontent: '';\n\tbackground: #939393;\n}\n.add-btn {\n\twidth: 25px;\n\theight: 25px;\n\tbackground: var(--ion-color-secondary);\n\tcolor: #ffffff;\n\tborder-radius: 5px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-size: 18px;\n\tmargin: 0px 0px 0px 5px;\n\t@include desktop {\n\t\tdisplay: none;\n\t}\n}\n\n.pfand-meirnveg {\n\tmargin: 0;\n\tfont-size: 12px;\n}\n\n.item-img {\n\tpadding: 0;\n\t@include desktop {\n\t\tdisplay: block;\n\t}\n}\n\n.image-wrapper {\n\tposition: relative;\n\twidth: 100%;\n\taspect-ratio: 1;\n\tborder-radius: 4px;\n\toverflow: hidden;\n\n\t.main-img {\n\t\tborder-radius: 1px;\n\t\toverflow: hidden;\n\t\tobject-fit: cover;\n\t\twidth: 100%;\n\t\taspect-ratio: 1;\n\n\t\t&.default {\n\t\t\theight: 100%;\n\t\t\tobject-fit: contain;\n\n\t\t}\n\t}\n\n\t.top-selling {\n\t\tposition: absolute;\n\t\ttop: 2px;\n\t\tleft: 50%;\n\t\ttransform: translateX(-50%);\n\t\theight: 25px;\n\t\twidth: 25px;\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
